import { housekeepingQueryKeys as e } from "./useHousekeepingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
//#region src/housekeeping/useWorkspaceOperationsSettingsQuery.ts
var r = (r) => t({
	queryKey: e.settings(),
	queryFn: () => n.getOperationsSettings(),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as useWorkspaceOperationsSettingsQuery };
